<template>
  <div class="mainDiv" :class="ctype != 'false' ? 'active' : ''" v-loading="loading">
    <h3 v-if="ctype == 'false'">{{ courseTitle }} - 学习结果</h3>
    <div class="tab">
      <el-collapse v-model="activeNames" v-if="ctype == 'false'">
        <el-collapse-item name="1">
          <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="mini" style="margin-left: 80px">
            <el-row>
              <el-col :span="6">
                <el-form-item prop="batchNameOrClassCode" label="开课批次/班级编码：" label-width="150px">
                  <el-col :span="20">
                    <el-input size="small" v-model="form.batchNameOrClassCode"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="albumTitle" label="班级名称：">
                  <el-col :span="20">
                    <el-input size="small" v-model="form.albumTitle" style="width: 100rpx"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="rkMhmName" label="任课机构：">
                  <el-col :span="20">
                    <el-input size="small" v-model="form.rkMhmName"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="rkTeacherName" label="任课老师：">
                  <el-col :span="20">
                    <el-input size="small" v-model="form.rkTeacherName"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="姓名：" label-width="150px">
                  <el-col :span="20">
                    <el-input v-model="form.fullName"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item prop="scoreStatus" label="总评">
                  <el-col :span="20">
                    <el-select ref="statusList" v-model="form.scoreStatus" placeholder="-不限-" clearable>
                      <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="成绩：" prop="finalScoreStartVal">
                  <el-col :span="5">
                    <el-input v-model="form.finalScoreStartVal"></el-input>
                  </el-col>
                  <el-col :span="1" style="width: 10px"> - </el-col>
                  <el-col :span="5">
                    <el-input v-model="form.finalScoreEndVal" ref="finalScoreEndVal"></el-input>
                  </el-col>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="btn" style="text-align: center">
              <el-row>
                <el-button type="primary" size="mini" @click="delAll">清空</el-button>
                <el-button type="primary" size="mini" @click="search">确定</el-button>
                <el-button size="mini" @click="toggle">关闭</el-button>
              </el-row>
            </div>
          </el-form>
        </el-collapse-item>
      </el-collapse>
      <!-- 开课管理的学习结果显示 -->
      <div class="class-result" v-if="ctype != 'false'">
        <div class="result-title">
          <nobr class="result-bg" v-if="className != 'null'">{{ className }}</nobr>
          <nobr v-if="applyBatch != 'null'">({{ applyBatch }})</nobr>
          <nobr class="result-bg" v-if="mhName != 'null'">--{{ mhName }}</nobr>
          <nobr v-if="uname != 'null'">({{ uname }})</nobr>
        </div>
        <!-- <div class="btn"> 
           <el-button type="primary"  @click="goBack">返回开课列表</el-button>
        </div> -->
      </div>
      <div class="control" v-if="ctype == 'false'">
        <el-button type="primary" @click="toggle">搜索</el-button>
        <el-button type="primary" @click="exportScore">导出筛选结果</el-button>
        <el-button type="primary" @click="sendMessage">提醒</el-button>
        <el-button type="primary" @click="importScoreDialogVisible = true">导入考核分</el-button>
        <el-button type="primary" @click="importAttendanceDialogVisible = true" v-if="userType === '1'">导入课堂考勤
        </el-button>
        <!-- <el-button type="primary" @click="scoreStatusTimeDialogVisible = true"
          >设置考核结束时间</el-button
        > -->
      </div>
      <el-dialog title="督学提醒" :visible.sync="tipsDialogVisible" :show-close="false" width="460px" destroy-on-close
        @close="closeTipsDialogVisible">
        <div class="tips_dialog">
          <el-form style="width: 100%" ref="tipsForm" :model="tipsForm" :rules="tipsRules">
            <el-form-item prop="tipsTextarea">
              <el-input type="textarea" :rows="6" v-model="tipsForm.tipsTextarea" />
            </el-form-item>

            <el-form-item label="">
              <el-radio-group v-model="tipsForm.usefulExpressions">
                <el-radio label="常用督学用语，常用督学用语" style="margin-bottom: 10px"></el-radio>
                <el-radio label="常用督学用语，常用督学用语"></el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="closeTipsDialogVisible">取 消</el-button>
          <el-button type="primary" @click="sendTips">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="导入考核分" :visible.sync="importScoreDialogVisible" width="30%" destroy-on-close>
        <span style="color: #d9001b">注：考核分导入只针对主观分类考核进行导入，包含：诚信表现、作业完成情况、互动完成情况、三种考核分进行批量导入，其它考核分数由系统自动生成</span>
        <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
          <el-button type="primary" @click="downloadTemplate('score')" style="margin-right: 50px; width: 126px">下载模板
          </el-button>
          <el-upload class="upload-demo" :action="url + '/zkfz/zkolCourseScore/importCourseCheckScore'"
            :show-file-list="false" :on-success="uploadImportCourseCheckScore" :on-error="failUpload"
            style="position: relative">
            <el-button type="primary">选择上传文件</el-button>
            <div slot="tip" class="el-upload__tip" style="position: absolute; bottom: -16px; left: 14px">
              只能上传excel文件
            </div>
          </el-upload>
        </span>
      </el-dialog>
      <el-dialog title="导入课堂考勤" :visible.sync="importAttendanceDialogVisible" width="30%" destroy-on-close>
        <span style="color: #d9001b">注：课堂考勤记录导入，包含：院校、学生名称、学号、课程名称、集中授课安排、课时、签到情况、签退情况、签到形式、有效学时时长</span>
        <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center">
          <el-button type="primary" @click="downloadTemplate('attendance')" style="margin-right: 50px; width: 126px">
            下载模板</el-button>
          <el-upload class="upload-demo" :action="url + '/zkfz/zkolCourseScore/importClassAttendance'"
            :show-file-list="false" :on-success="uploadClassAttendance" :on-error="failUpload"
            style="position: relative">
            <el-button type="primary">选择上传文件</el-button>
            <div slot="tip" class="el-upload__tip" style="position: absolute; bottom: -16px; left: 14px">
              只能上传excel文件
            </div>
          </el-upload>
        </span>
      </el-dialog>
    </div>

    <el-table :data="tableData" border style="width: 100%" size="small" @sort-change="sortChange"
      :header-cell-style="{ 'background-color': '#e8eff9' }" class="score_table">
      <el-table-column width="50">
        <template slot="header">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" />
        </template>
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.checked" @change="handleCheckOneChange" />
        </template>
      </el-table-column>
      <el-table-column width="50" label="序号" prop="rowNum"></el-table-column>
      <el-table-column label="开课批次/班级编码" prop="batchName">
        <template slot-scope="scope">
          {{ scope.row.classCode ? scope.row.classCode : scope.row.batchName }}
        </template>
      </el-table-column>
      <el-table-column label="班级名称" prop="albumTitle" sortable="custom"></el-table-column>
      <el-table-column label="任课机构" prop="rkMhmName" sortable="custom"></el-table-column>
      <el-table-column label="任课老师" prop="rkTeacherName" sortable="custom"></el-table-column>
      <!-- <el-table-column prop="uname" label="用户名">
        <template slot-scope="scope">
          <div
            @click="
              showGeneralTest(scope.row.fullName, scope.row.courseScoreId)
            "
          >
            {{ scope.row.uname }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column prop="fullName" label="姓名" sortable="custom">
        <template slot-scope="scope">
          <div @click="
            showGeneralTest(scope.row.fullName, scope.row.courseScoreId)
          ">
            {{ scope.row.fullName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="attendanceFinishInfo" label="学习时长">
        <template slot-scope="scope">
          <div @click="showStudyTime(scope.row.fullName, scope.row.courseScoreId)">
            {{ scope.row.attendanceFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="exerciseFinishInfo" label="练习完成情况">
        <template slot-scope="scope">
          <div @click="
            showCompletionScore(
              scope.row.fullName,
              '练习',
              '1',
              scope.row.courseScoreId
            )
          ">
            {{ scope.row.exerciseFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="testFinishInfo" label="阶段作业">
        <template slot-scope="scope">
          <div @click="
            showCompletionScore(
              scope.row.fullName,
              '阶段作业',
              '2',
              scope.row.courseScoreId
            )
          ">
            {{ scope.row.testFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="generalTestScore" label="综合测评">
        <template slot-scope="scope">
          <div @click="comprehensive(scope.row)">
            {{ scope.row.generalTestScore }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="moralScore" label="政治思想
品德">
      </el-table-column>
      <el-table-column prop="classAttendanceFinishInfo" label="课堂出勤情况">
        <template slot-scope="scope">
          <div @click="
            showClassAttendance(
              scope.row.fullName,
              scope.row.courseScoreId,
              scope.row.uid,
              scope.row.batchId
            )
          ">
            {{ scope.row.classAttendanceFinishInfo }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="homeworkScore" label="作业完成情况">
        <template slot-scope="scope">
          <div @click="
            showGeneralTest(scope.row.fullName, scope.row.courseScoreId)
          ">
            {{ scope.row.homeworkScore }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="interactScore" label="互动完成情况">
        <template slot-scope="scope">
          <div @click="
            showGeneralTest(scope.row.fullName, scope.row.courseScoreId)
          ">
            {{ scope.row.interactScore }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="finalScore" label="成绩" width="80" sortable="custom">
      </el-table-column>
      <el-table-column prop="scoreStatus" label="总评" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.orderOver === false" class="indicatorIncomplete" @click="
            showGeneralTest(
              scope.row.fullName,
              scope.row.courseScoreId,
              scope.row.uid
            )
          ">
            未到考核时间
          </div>
          <div v-if="scope.row.orderOver === true" :class="
            scope.row.scoreStatus === '未到考核时间'
              ? 'indicatorIncomplete'
              : ''
          " @click="
  showGeneralTest(
    scope.row.fullName,
    scope.row.courseScoreId,
    scope.row.uid
  )
">
            {{ scope.row.scoreStatus }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="assessEndTime" label="考核结束时间" width="100">
        <template slot-scope="scope">
          <div>
            {{ scope.row.assessEndTime[0] }}
          </div>
          <div>
            {{ scope.row.assessEndTime[1] }}
          </div>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="130" header-align="center" v-if="ctype != 'false'">
        <template slot-scope="scope">
          <div class="table_control">
            <span
              class="table_control_item"
              @click="lookReport(scope.row)"
              >查看上报记录</span
            >
            <span class="table_control_item" @click="sendMessages(scope.row)">
              |督学</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]" :page-size="pageObj.pageSize" layout="total, sizes, prev, pager, next, jumper"
      background :total="total">
    </el-pagination>
    <el-dialog :title="generalTestFullName + '综合考核情况'" :visible.sync="generalTestDialogVisible" width="670px"
      @close="closeGeneralTest">
      <el-form ref="generalTestForm" :model="generalTestForm" label-width="120px">
        <el-row type="flex">
          <el-col>
            <el-form-item label="成绩 : ">
              <el-input v-model="generalTestForm.finalScore" size="small" style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="总评 : ">
              <el-input v-model="generalTestForm.scoreStatus" size="small"
                :class="isIndicatorIncomplete ? 'indicatorIncomplete' : ''" style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="学习时长 : ">
              <el-input v-model="generalTestForm.attendanceFinishInfo" size="small" style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="练习完成情况 : ">
              <el-input v-model="generalTestForm.exerciseFinishInfo" size="small" style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="测验完成情况 : ">
              <el-input v-model="generalTestForm.testFinishInfo" size="small" style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="综合测评 : ">
              <el-input v-model="generalTestForm.generalTestScore" size="small" style="width: 180px"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="诚信表现 : ">
              <el-input v-model="generalTestForm.moralScore" size="small" placeholder="-请输入考试分数-"
                class="generalScoreTips" style="width: 180px" @blur="
                  saveCourseScore(
                    generalTestForm.courseScoreId,
                    'moralScore',
                    generalTestForm.moralScore
                  )
                "></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="课堂出勤情况 : ">
              <el-input v-model="generalTestForm.classAttendanceFinishInfo" size="small" placeholder="请输入出勤情况"
                class="generalScoreTips" style="width: 180px" @focus="
                  focusClassAttendance(
                    generalTestForm.fullName,
                    generalTestForm.courseScoreId,
                    generalTestForm.uid,
                    generalTestForm.batchId
                  )
                "></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex">
          <el-col>
            <el-form-item label="作业完成情况 : ">
              <el-input v-model="generalTestForm.homeworkScore" size="small" placeholder="-请输入考试分数-"
                class="generalScoreTips" style="width: 180px" @blur="
                  saveCourseScore(
                    generalTestForm.courseScoreId,
                    'homeworkScore',
                    generalTestForm.homeworkScore
                  )
                "></el-input>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="互动完成情况 : ">
              <el-input v-model="generalTestForm.interactScore" size="small" placeholder="-请输入考试分数-"
                class="generalScoreTips" style="width: 180px" @blur="
                  saveCourseScore(
                    generalTestForm.courseScoreId,
                    'interactScore',
                    generalTestForm.interactScore
                  )
                "></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="generalTestDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="attendanceFullName + '学习时长'" :visible.sync="studyTimeDialogVisible" width="670px">
      <el-table :data="attendanceCompletionData" border size="mini" height="560">
        <el-table-column property="rowNum" label="序号" align="center" width="50"></el-table-column>
        <el-table-column property="videoTitle" label="课件资源" align="center" min-width="150"></el-table-column>
        <el-table-column property="videoType" label="类型" align="center" width="80"></el-table-column>
        <el-table-column property="finishStatus" label="完成情况" align="center" width="110"></el-table-column>
        <el-table-column property="learnTime" label="学习时长" align="center" width="130"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="studyTimeDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="`${completionScoreFullName}${completionScoreTitle}完成情况`"
      :visible.sync="completionScoreDialogVisible" width="670px">
      <el-table :data="thirdCompletionData" border size="mini" height="560">
        <el-table-column property="rowNum" label="序号" align="center" width="50"></el-table-column>
        <el-table-column property="videoTitle" label="课件资源" align="center" min-width="150"></el-table-column>
        <el-table-column property="videoType" label="类型" align="center" width="80"></el-table-column>
        <el-table-column property="finishStatus" label="完成情况" align="center" width="110"></el-table-column>
        <el-table-column property="topScore" label="最高成绩" align="center" width="130"></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="completionScoreDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="classAttendanceFullName + '课堂出勤情况'" :visible.sync="classAttendanceDialogVisible" width="670px">
      <el-table :data="classAttendanceData" border size="mini" height="560">
        <el-table-column property="rowNum" label="序号" align="center" width="50"></el-table-column>
        <el-table-column property="videoTitle" label="集中授课安排" align="center" min-width="150"></el-table-column>
        <el-table-column property="videoType" label="类型" align="center" width="60"></el-table-column>
        <el-table-column property="signInfo" label="签到情况" align="center" width="80">
          <template slot-scope="scope">
            <div style="cursor: pointer" @click="changeSignInfo(scope.row.signInfo, scope.$index)">
              {{ scope.row.signInfo }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="signOutInfo" label="签退情况" align="center" width="80">
          <template slot-scope="scope">
            <div style="cursor: pointer" @click="changeSignInfo(scope.row.signOutInfo, scope.$index)">
              {{ scope.row.signOutInfo }}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="learnTime" label="有效学习时长" align="center" width="130"></el-table-column>
      </el-table>
      <div style="margin-top: 20px; color: #d9001b">
        温馨提示: 点击对应签到或签退单元格进行修改
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="changeClassAttendance">保存</el-button>
        <el-button type="primary" @click="classAttendanceDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="设置考核结束时间：" :visible.sync="scoreStatusTimeDialogVisible" class="score_status_time_dialog"
      @close="closeScoreStatusTimeDialog" width="670px">
      <el-date-picker v-model="scoreStatusTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"
        style="width: 80%">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setScoreStatusTime">确定</el-button>
      </span>
    </el-dialog>


    <!-- 查看上报记录弹窗  -->
    <el-dialog
      :title="reportFullName + className + '考核上报记录'"
      :visible.sync="reportDialogVisible"
      :modal="showModal"
      width="1200px"
    >
      <el-table
        :data="reportData"
        border
        size="mini"
        height="560"
      >
        <el-table-column
          property="rowNum"
          label="序号"
          align="center"
          width="50"
        ></el-table-column>
        <el-table-column
          property="reportTime"
          label="上报时间"
          align="center"
          min-width="100"
        ></el-table-column>
        <el-table-column
          property="attendanceScore"
          label="学习时长"
          align="center"
          width="80"
        ></el-table-column>
        <el-table-column
          property="exerciseScore"
          label="练习完成情况"
          align="center"
          width="110"
        ></el-table-column>
        <el-table-column
          property="testScore"
          label="阶段作业"
          align="center"
          width="80"
        ></el-table-column>
         <el-table-column
          property="generalTestScore"
          label="综合测评"
          align="center"
          width="80"
        ></el-table-column>
         <el-table-column
          property="moralScore"
          label="政治思想品德"
          align="center"
          width="130"
        ></el-table-column>
         <el-table-column
          property="classAttendanceScore"
          label="课堂出勤情况"
          align="center"
          width="130"
        ></el-table-column>
         <el-table-column
          property="homeworkScore"
          label="作业完成情况"
          align="center"
          width="130"
        ></el-table-column> <el-table-column
          property="interactScore"
          label="互动完成情况"
          align="center"
          width="130"
        ></el-table-column>
         <el-table-column
          property="finalScore"
          label="成绩"
          align="center"
          width="60"
        ></el-table-column>
         <el-table-column
          property="scoreStatus"
          label="总评"
          align="center"
          width="60"
        ></el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="reportDialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>

    <!-- 综合测验查看试卷 -->
    <el-dialog :title="scoreTitle" :visible.sync="comprehensiveVisible" class="score_status_time_dialog"
      @close="closeComprehensiveDialog" width="1200px">
      <div class="examTime-box" v-if="isShowExam">
        <div class="examTime">考试时间:{{ examAndTime }}</div>
        <div class="examTime">考试用时: {{ spaceTime }}</div>
      </div>
      <div class="exam-info" v-if="isShowExam">
        <div class="topic" v-for="(item, index) in comprehensiveList" :key="index">
          <div class="header-box">
            <div class="title-type">{{ item.questionTypeTitle }}</div>
            <div class="bg-active">(得分:{{ item.score || 0 }}分)</div>
          </div>
          <div class="question">
            <div class="question-title">
              {{ index + 1 + '、' }}{{ item.content + '( )' }}
            </div>
            <div class="select-anwer">
              <div class="anwer" v-for="(d, i) in item.nameArr" :key="i">{{ d.name }}</div>
            </div>
            <div class="anwer-box">
              <div class="anwer-user">用户答案：{{ item.answer }}</div>

              <div class="anwer-user">正确答案：<nobr v-for="(d, i) in item.answerTrueOption" :key="i">{{ d }}</nobr>
              </div>
            </div>
            <div class="analyze-box">
              解析：{{ item.analyze }}
            </div>
          </div>
        </div>
      </div>
      <div class="allScore" v-if="isShowExam">
        最终得分：{{ allScore || 0 }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goBackLast">返回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as api from "@/api/learningOutcome/learningOutcome";
import * as api1 from '@/api/LookReport/index.js'
import * as api2 from "@/api/course/courseInformation.js";
import * as api3 from "@/api/courseware/checkCourseware";
export default {
  props: {
    className: {
      type: String,
      default: ''
    },
    applyBatch: {
      type: String,
      default: ''
    },
    mhName: {
      type: String,
      default: ''
    },
    uname: {
      type: String,
      default: ''
    },
    ctype: {
      type: String,
      default: 'false'
    },
    batchId: {
      type: String,
      default: ''
    },
  },
  data() {
    const patternZeroToHundredInteger = /^([0-9]{1,2}|100)$/; //0到100整数
    const validZeroToHundredInteger = (value, callback, endDom) => {
      const endVal = endDom.value || "";
      (patternZeroToHundredInteger.test(value) || value === "") &&
        (patternZeroToHundredInteger.test(endVal) || endVal === "")
        ? callback()
        : callback(new Error("请输入整数0~100"));
    };
    const validAttendanceFinish = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.attendanceFinishEndVal
      );
    };
    const validInteractFinish = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.interactFinishEndVal
      );
    };
    const validExerciseFinish = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.exerciseFinishEndVal
      );
    };
    const validHomeworkFinish = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.homeworkFinishEndVal
      );
    };
    const validTestFinishStartVal = (rule, value, callback) => {
      validZeroToHundredInteger(value, callback, this.$refs.testFinishEndVal);
    };
    const validGeneralTestScore = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.generalTestScoreEndVal
      );
    };
    const validClassAttendanceFinish = (rule, value, callback) => {
      validZeroToHundredInteger(
        value,
        callback,
        this.$refs.classAttendanceFinishEndVal
      );
    };
    const validMoralScore = (rule, value, callback) => {
      validZeroToHundredInteger(value, callback, this.$refs.moralScoreEndVal);
    };
    const validFinalScore = (rule, value, callback) => {
      validZeroToHundredInteger(value, callback, this.$refs.finalScoreEndVal);
    };
    return {
      loading: false,
      uid: "",
      courseId: this.$route.query.courseId || "",
      // batchId: this.$route.query.batchId || "",
      // ctype: this.$route.query.ctype ? this.$route.query.ctype : false,
      courseScoreId: "",
      courseTitle: "",
      activeName: "first",
      activeNames: [],
      form: {
        batchNameOrClassCode: "",
        albumTitle: "",
        rkMhmName: "",
        rkTeacherName: "",
        fullName: "",
        // 成绩
        finalScoreStartVal: "",
        finalScoreEndVal: "",
        // 总评
        scoreStatus: "",
      },
      rules: {
        // batchNameOrClassCode:[{ required: false, message: '请输入考点名称', trigger: 'blur' }],
        // albumTitle:[{ required: false, message: '请输入考点名称', trigger: 'blur' }],
        // rkMhmName:[{ required: false, message: '请输入考点名称', trigger: 'blur' }],
        // rkTeacherName:[{ required: false, message: '请设置日期', trigger: 'blur' }],
        // fullName:[{ required: false, message: '请设置开始时间', trigger: 'blur' }],
        // scoreStatus:[{ required: false, message: '请设置结束时间', trigger: 'blur' }],

        moralScoreStartVal: [{ validator: validMoralScore, trriger: "change" }],
        finalScoreStartVal: [{ validator: validFinalScore, trriger: "change" }],
      },
      checkAll: false,
      isIndeterminate: false,
      tableData: [],

      tipsDialogVisible: false,
      tipsUser: [], //提醒的学生
      tipsForm: {
        tipsTextarea: "",
        usefulExpressions: "",
      },
      tipsRules: {
        tipsTextarea: [
          { required: true, trriger: "blur", message: "内容不能为空" },
        ],
      },
      importScoreDialogVisible: false,
      importAttendanceDialogVisible: false,

      generalTestFullName: "",
      generalTestDialogVisible: false,
      generalTestForm: {},
      isIndicatorIncomplete: false,

      studyTimeDialogVisible: false,
      attendanceFullName: "",
      attendanceCompletionData: [],

      classAttendanceDialogVisible: false,
      classAttendanceFullName: "",
      classAttendanceBatchId: "",
      classAttendanceData: [],

      completionScoreDialogVisible: false,
      completionScoreFullName: "",
      thirdCompletionData: [],
      completionScoreTitle: "",
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      isSaveClassAttendance: true,
      courseScoreIdToHandleClick: "", //点击切换签到签退时用的id
      scoreStatusTimeDialogVisible: false,
      scoreStatusTime: "",
      sortObj: {
        orderByField: "",
        orderBy: "",
      },
      userType: null, // 用户类型
      statusList: [
        {
          label: "-不限-",
          value: "",
        },
        {
          label: "优秀",
          value: "1",
        },
        {
          label: "良好",
          value: "2",
        },
        {
          label: "合格",
          value: "3",
        },
        {
          label: "不及格",
          value: "4",
        },
        {
          label: "指标不全",
          value: "5",
        },
        {
          label: "未到考核时间",
          value: "6",
        },
      ],

      // 学习结果参数
      // className: this.$route.query.className ,
      // applyBatch:this.$route.query.applyBatch ,
      // mhName:this.$route.query.mhName ,
      // uname:this.$route.query.className ,
      // 综合测验查看试卷弹窗
      comprehensiveVisible: false,
      // 弹窗标题
      scoreTitle: '',
      // 
      comprehensiveList: [],
      // 最终得分
      allScore: '',
      // 用户答案
      answersOptions: [],
      spaceTime: '',
      // 考试时间
      examAndTime: '',
      // 是否显示考卷
      isShowExam: false,

      reportDialogVisible:false,
      reportFullName:'',
      className:'',
      reportData:[],

    };
  },
  created() {
    this.getCourseTitle();
    this.getCourseScore();
    this.getUserByUid();
  },
  computed: {
    getUId() {
      return localStorage.getItem("uid");
    },
    url() {
      let url = window.location.protocol + "//" + window.location.host;
      if (window.location.host == "localhost:5001") {
        url = "http://gz.hnjk.net";
      }
      return url;
    },
  },
  methods: {
    //获取课程名称
    getCourseTitle() {
      api2.getViewCourseDetail({ id: this.courseId }).then((data) => {
        this.courseTitle = data.data.data.videoTitle;
      });
    },
    //获取学习结果列表（分页）
    getCourseScore() {
      this.loading = true;
      if (this.ctype == 'true') {
        api
          .getCourseScore({
            ...this.form,
            batchId: this.batchId,
            orderAlbumId: "",
            ...this.pageObj,
            ...this.sortObj,
          })
          .then((data) => {
            if (data.data.code === 100000) {
              const dataObj = data.data.data.page;
              this.total = dataObj.total;
              this.tableData = dataObj.list.map((item) => {
                return {
                  ...item,
                  checked: false,
                  assessEndTime: (item.assessEndTime &&
                    item.assessEndTime.split(" ")) || ["", ""],
                };
              });
              this.loading = false;
            } else {
              this.$message.error(data.data.msg);
              this.loading = false;
            }
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      } else {
        api
          .getCourseScore({
            ...this.form,
            courseId: this.courseId,
            orderAlbumId: "",
            ...this.pageObj,
            ...this.sortObj,
          })
          .then((data) => {
            if (data.data.code === 100000) {
              const dataObj = data.data.data.page;
              this.total = dataObj.total;
              this.tableData = dataObj.list.map((item) => {
                return {
                  ...item,
                  checked: false,
                  assessEndTime: (item.assessEndTime &&
                    item.assessEndTime.split(" ")) || ["", ""],
                };
              });
              this.loading = false;
            } else {
              this.$message.error(data.data.msg);
              this.loading = false;
            }
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }

    },
    //搜索的折叠面板
    toggle() {
      this.activeNames.length
        ? (this.activeNames = [])
        : (this.activeNames = ["1"]);
    },
    //清空搜索内容
    delAll() {
      // this.form = this.$options.data().form
      this.form = {
        batchNameOrClassCode: "",
        albumTitle: "",
        rkMhmName: "",
        rkTeacherName: "",
        fullName: "",
        // 成绩
        finalScoreStartVal: "",
        finalScoreEndVal: "",
        // 总评
        scoreStatus: "",
      };
      this.pageObj.page = 1;
      this.getCourseScore();
    },
    //搜索
    search() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return this.$message.error("请输出正确的值或为空");
        }
        this.pageObj.page = 1;
        this.getCourseScore();
        // this.$message({
        //   type: 'success',
        //   message: '操作成功',
        // })
      });
    },
    //导出excel
    exportScore() {
      const {
        batchNameOrClassCode,
        albumTitle,
        rkMhmName,
        rkTeacherName,
        fullName,
        // 成绩
        finalScoreStartVal,
        finalScoreEndVal,
        // 总评
        scoreStatus,
      } = this.form;
      window.open(
        `${this.url}/zkfz/zkolCourseScore/exportExcel?courseId=${this.courseId}&albumTitle=${albumTitle}&batchNameOrClassCode=${batchNameOrClassCode}&rkMhmName=${rkMhmName}&rkTeacherName=${rkTeacherName}&fullName=${fullName}&finalScoreStartVal=${finalScoreStartVal}&finalScoreEndVal=${finalScoreEndVal}&scoreStatus=${scoreStatus}`
      );
    },
    // 打开提醒框
    sendMessage() {
      const index = this.tableData.findIndex((item) => item.checked === true);
      if (index === -1) {
        this.$message.error("请选择要提醒的学生！");
      } else {
        const arr = [];
        this.tableData.forEach((item) => {
          if (item.checked) {
            arr.push({ courseScoreId: item.courseScoreId });
          }
        });
        console.log(arr);
        this.tipsUser = arr;
        this.tipsDialogVisible = true;
      }
    },
    // 督学
    sendMessages(val) {
      const arr = [];
      arr.push({ courseScoreId: val.courseScoreId });
      this.tipsUser = arr
      this.tipsDialogVisible = true;
    },
    //发送提醒
    sendTips() {
      this.$refs.tipsForm.validate((valid) => {
        if (!valid) {
          return this.$message.error("操作失败");
        }
        const message = this.tipsForm.tipsTextarea;
        let courseScoreIds = [];
        this.tipsUser.forEach((item) => {
          courseScoreIds.push(item.courseScoreId);
        });
        api.sendMessage({ courseScoreIds, message }).then((data) => {
          console.log(data);
          const { code, msg } = data.data;
          if (code === 100000) {
            this.tipsDialogVisible = false;
            this.$message({
              type: "success",
              message: msg,
            });
          }
        });
      });
    },
    //下载模板
    downloadTemplate(type) {
      let {
        batchNameOrClassCode,
        albumTitle,
        rkMhmName,
        rkTeacherName,
        fullName,
        // 成绩
        finalScoreStartVal,
        finalScoreEndVal,
        // 总评
        scoreStatus,
      } = this.form;

      let condition = `?courseId=${this.courseId}&albumTitle=${albumTitle}&batchNameOrClassCode=${batchNameOrClassCode}&rkMhmName=${rkMhmName}&rkTeacherName=${rkTeacherName}&fullName=${fullName}&finalScoreStartVal=${finalScoreStartVal}&finalScoreEndVal=${finalScoreEndVal}&scoreStatus=${scoreStatus}`;
      console.log("type", type, condition);

      if (type === "score") {
        window.open(
          this.url +
          "/zkfz/zkolCourseScore/exportCourseCheckScoreModel" +
          condition
        );
      } else if (type === "attendance") {
        window.open(
          this.url +
          "/zkfz/zkolCourseScore/exportClassAttendanceModel" +
          condition
        );
      }
    },
    //导入考核分
    uploadImportCourseCheckScore(res, file, fileList) {
      let formdata = new FormData();
      formdata.append("file", file.raw);
      formdata.append("courseId", this.courseId);
      formdata.append("createBy", localStorage.getItem("uid"));
      api.importCourseCheckScore(formdata).then((data) => {
        const { code, msg } = data.data;
        if (code === 100000) {
          this.$message.success(msg);
          this.getCourseScore();
          this.importScoreDialogVisible = false;
        } else {
          this.$message.error(msg);
        }
      });
    },
    //导入课堂考勤
    uploadClassAttendance(res, file, fileList) {
      let formdata = new FormData();
      formdata.append("file", file.raw);
      formdata.append("courseId", this.courseId);
      formdata.append("createBy", localStorage.getItem("uid"));
      api.importClassAttendance(formdata).then((data) => {
        const { code, msg } = data.data;
        if (code === 100000) {
          this.$message.success(msg);
          this.getCourseScore();
          this.importAttendanceDialogVisible = false;
        } else {
          this.$message.error(msg);
        }
      });
    },
    failUpload(err) {
      this.$message.error(err);
    },
    //关闭提醒框
    closeTipsDialogVisible() {
      this.tipsDialogVisible = false;
      this.tipsForm.tipsTextarea = "";
    },
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      this.tableData.forEach((item) => {
        item.checked = val;
      });
    },
    handleCheckOneChange(val) {
      let totalCount = this.tableData.length;
      let someStatusCount = 0;
      this.tableData.forEach((item) => {
        if (item.checked === val) {
          someStatusCount++;
        }
      });
      this.checkAll = totalCount === someStatusCount ? val : !val;
      this.isIndeterminate =
        someStatusCount > 0 && someStatusCount < totalCount;
    },
    //设置总评截止时间
    setScoreStatusTime() {
      api
        .setCourseAssessEndTime({
          courseId: this.courseId,
          assessEndTime: this.scoreStatusTime,
        })
        .then(({ data }) => {
          const { code, msg } = data;
          if (code === 100000) {
            this.getCourseScore();
            this.scoreStatusTimeDialogVisible = false;
            this.$message.success(msg);
          } else {
            this.$message.error(msg);
          }
        });
    },
    closeScoreStatusTimeDialog() {
      this.scoreStatusTime = "";
    },
    //综合考核情况对话框
    showGeneralTest(name, courseScoreId, uid) {
      this.generalTestFullName = name;
      this.uid = uid;
      this.getOverallCourseScoreInfo(courseScoreId);
    },
    //获取综合考核情况
    getOverallCourseScoreInfo(courseScoreId) {
      this.courseScoreId = courseScoreId;
      api.getOverallCourseScoreInfo({ courseScoreId }).then((data) => {
        const { code, data: list, msg } = data.data;
        if (code === 100000) {
          const {
            scoreStatus,
            moralScore,
            classAttendanceFinishInfo,
            homeworkScore,
            interactScore,
            orderOver,
          } = list;
          const checkScore = {
            moralScore,
            classAttendanceFinishInfo,
            homeworkScore,
            interactScore,
          };
          for (let key in checkScore) {
            if (checkScore[key].indexOf("-") > -1) list[key] = "";
          }
          if (orderOver === false) {
            list.scoreStatus = "未到考核时间";
            this.isIndicatorIncomplete = true;
          } else {
            if (scoreStatus === "未到考核时间") {
              this.isIndicatorIncomplete = true;
            }
          }
          this.generalTestForm = list;
          this.generalTestDialogVisible = true;
        } else {
          this.$message.error(msg);
        }
      });
    },
    //修改综合考勤成绩
    saveCourseScore(id, type, val) {
      this.$confirm("确定要更改吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
        center: true,
      })
        .then(() => {
          if (val.includes("分")) val = val.replace("分", "");
          api.saveCourseScore({ id, [type]: val }).then((data) => {
            const { code, msg } = data.data;
            if (code === 100000) {
              this.getCourseScore();
              this.$message.success(msg);
            } else {
              this.$message.error(msg);
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //综合考核中打开课堂出勤
    focusClassAttendance(name, courseScoreId, uid, batchId) {
      this.showClassAttendance(name, courseScoreId, uid, batchId);
    },
    //排序
    sortChange({ column, prop, order }) {
      this.sortObj.orderByField = prop;
      if (order && order.indexOf("desc") !== -1) {
        this.sortObj.orderBy = "desc";
      } else {
        this.sortObj.orderBy = "asc";
      }
      this.getCourseScore();
    },
    //修改课堂出勤情况
    changeClassAttendance() {
      let data = [];
      this.classAttendanceData.forEach((item) => {
        let courseName = item.videoTitle;
        let courseType = "";
        let id = item.id;
        let signInfo = item.signInfo;
        let signOutInfo = item.signOutInfo;
        if (item.videoType.indexOf("面授") > -1) {
          courseType = 1;
        } else if (item.videoType.indexOf("直播") > -1) {
          courseType = 2;
        }
        data.push({ courseName, courseType, signInfo, signOutInfo, id });
      });
      api
        .saveClassAttendance({
          classAttendanceBatchId: this.classAttendanceBatchId,
          courseId: this.courseId,
          uid: this.uid,
          zkolClassAttendanceDetails: data,
        })
        .then(({ data }) => {
          if (data.code === 100000) {
            if (this.courseScoreId) {
              this.getOverallCourseScoreInfo(this.courseScoreId);
            }
            this.getCourseScore();
            // if (this.isSaveClassAttendance) {
            this.classAttendanceDialogVisible = false;
            this.$message.success(data.msg);
            // } else {
            //   this.showClassAttendance(
            //     this.classAttendanceFullName,
            //     this.courseScoreIdToHandleClick,
            //     this.uid
            //   )
            // }
          } else {
            this.$message.error(data.msg);
          }
        });
    },
    //分钟转时分秒
    minToClock(min) {
      let h = Math.floor(min / 60);
      h = h > 10 ? h : "0" + h;
      let m = min % 60;
      m = m > 10 ? m : "0" + m;
      if (min.toString().includes(".5")) {
        m = Math.floor(m);
        m = m > 10 ? m : "0" + m;
        return `${h}:${m}:30`;
      } else {
        return `${h}:${m}:00`;
      }
    },
    //切换签到签退情况
    changeSignInfo(val, index) {
      // this.isSaveClassAttendance = false
      const period = this.classAttendanceData[index].period;
      if (period === null) {
        return this.$message.error("未设置课时");
      }
      if (val === "已签到") {
        this.classAttendanceData[index].signInfo = "未签到";
      }
      if (val === "未签到") {
        this.classAttendanceData[index].signInfo = "已签到";
      }
      if (val === "未签退") {
        this.classAttendanceData[index].signOutInfo = "已签退";
      }
      if (val === "已签退") {
        this.classAttendanceData[index].signOutInfo = "未签退";
      }
      // this.changeClassAttendance()
      if (period === 0) {
        return this.$message("课时为0");
      }
      const timeOfOnePeriod = 45;
      const halfPeriod = period / 2;
      let time = timeOfOnePeriod * period;
      time = this.minToClock(time);
      let halfTime = timeOfOnePeriod * halfPeriod;
      halfTime = this.minToClock(halfTime);
      const signInfo = this.classAttendanceData[index].signInfo;
      const signOutInfo = this.classAttendanceData[index].signOutInfo;
      if (signInfo === "未签到" && signOutInfo === "未签退") {
        this.classAttendanceData[index].learnTime = "00:00:00";
      } else if (signInfo === "未签到" && signOutInfo === "已签退") {
        this.classAttendanceData[index].learnTime = halfTime;
      } else if (signInfo === "已签到" && signOutInfo === "未签退") {
        this.classAttendanceData[index].learnTime = halfTime;
      } else if (signInfo === "已签到" && signOutInfo === "已签退") {
        this.classAttendanceData[index].learnTime = time;
      }
    },
    closeGeneralTest() {
      this.generalTestForm = {};
      this.courseScoreId = "";
    },
    //学习时长对话框
    showStudyTime(name, courseScoreId) {
      this.attendanceFullName = name;
      api
        .getCourseScoreInfo({ courseScoreId, infoStatus: "0" })
        .then((data) => {
          const { code, data: list, msg } = data.data;
          if (code === 100000) {
            this.attendanceCompletionData = list.result;
            this.studyTimeDialogVisible = true;
          } else {
            this.$message.error(msg);
          }
        });
    },
    //课堂出勤情况对话框
    showClassAttendance(name, courseScoreId, uid, batchId) {
      this.uid = uid;
      this.classAttendanceFullName = name;
      this.classAttendanceBatchId = batchId;
      // this.courseScoreIdToHandleClick = courseScoreId
      api
        .getCourseScoreInfo({ courseScoreId, infoStatus: "3" })
        .then((data) => {
          const { code, data: list, msg } = data.data;
          if (code === 100000) {
            this.classAttendanceData = list.result;
            this.classAttendanceDialogVisible = true;
            this.isSaveClassAttendance = true;
          } else {
            this.$message.error(msg);
          }
        });
    },
    //完成情况分数对话框
    showCompletionScore(name, title, infoStatus, courseScoreId) {
      this.completionScoreFullName = name;
      this.completionScoreTitle = title;
      api.getCourseScoreInfo({ courseScoreId, infoStatus }).then((data) => {
        const { code, data: list, msg } = data.data;
        if (code === 100000) {
          this.thirdCompletionData = list.result;
          this.completionScoreDialogVisible = true;
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val;
      this.getCourseScore();
    },
    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val;
      this.getCourseScore();
    },
    // 获取用户信息
    getUserByUid() {
      api3.getUserByUid(this.getUId).then(({ data }) => {
        if (data.code === 100000) {
          this.userType = data.data.type;
        }
      });
    },
    // 返回开课列表
    // goBack(){
    //   this.$router.push(`/CourseContentManager`)
    // },
    // 查看上报记录
    lookReport(val){
      this.reportFullName = val.fullName
      this.className =  val.courseName ? '(' + val.courseName +')' : ''
      const params = {
          uid: this.getUId,
          batchId: val.batchId,
          videoId: this.courseId,
      }
       api1.getScoreReports(params).then(({ data }) => {
        if (data.code === 100000) {
          console.log(data);
          this.reportData = data.data
          this.reportDialogVisible = true
        }
      })
    },
    // 不限选择
    //  visibleChange(e) {
    //   if (!e) {
    //     // this.$refs.testTypeList.blur()
    //     // this.$refs.testModeList.blur()
    //     this.$refs.statusList.blur()
    //     this.$refs.videoTypeList.blur()
    //     // this.$refs.coursePropertiesList.blur()
    //   }
    // },
    comprehensive(val) {
      console.log(val)
      this.scoreTitle = val.fullName + '(' + val.courseName + ')' + "综合测评成绩"
      this.getExamDetail(val)
    },
    // 关闭综合测验弹窗
    closeComprehensiveDialog() {
      console.log("关闭");
    },
    // 关闭弹窗
    goBackLast() {
      this.comprehensiveVisible = false
    },
    /**
   * 秒数转化为时、分、秒00:00：00
   */
    getTime(time) {
      var secondTime = parseInt(time); // 秒
      var minuteTime = 0; // 分
      var hourTime = 0; // 小时
      if (secondTime >= 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        // if (minuteTime >= 60) {
        // 	hourTime = parseInt(minuteTime / 60);
        // 	minuteTime = parseInt(minuteTime % 60);
        // }
      }
      var result = "" + (parseInt(secondTime) < 10 ? "0" + parseInt(secondTime) : parseInt(secondTime)) + '秒';
      console.log(result);
      if (minuteTime > 0) {
        result = "" + (parseInt(minuteTime) < 10 ? "0" + parseInt(minuteTime) : parseInt(minuteTime)) + "分钟" + result;
      }
      if (hourTime > 0) {
        result = "" + (parseInt(hourTime) < 10 ? "0" + parseInt(hourTime) : parseInt(hourTime)) + ":" + result;
      }
      console.log(result);
      return result
    },
    // 获取课程试卷数据
    getExamDetail(val) {
      const params = {
        // val.batchId
        // val.courseId
        // localStorage.getItem("uid")
        // batchId: 'c5a6d8800be84e6ca0ef3d110e59745d',
        // courseId:'961',
        // uid: '19410',

        batchId: val.batchId,
        courseId: val.courseId,
        uid: val.uid,
      }

      api.getStuExam(params).then((data) => {
        const { code, msg } = data.data;
        if (code === 100000) {
          this.comprehensiveVisible = true
          if (Object.keys(data.data.data).length == 0) {
            this.isShowExam = false
          } else {
            // 未考试不显示考卷
            this.isShowExam = true
            console.log("综合数据", data.data.data);
            //  最终得分
            this.allScore = data.data.data.examsUsers ? data.data.data.examsUsers.score : 0
            this.answersOptions = data.data.data.answersOptions
            //  考试用时处理
            this.spaceTime = this.getTime(data.data.data.examsUsers ? data.data.data.examsUsers.anserTime : 0)
            //  考试时间处理
            const starTimeArr = data.data.data.examsUsers ? data.data.data.examsUsers.examTime.split(':') : 0
            const endTimeArr = data.data.data.examsUsers ? data.data.data.examsUsers.createTime.split(':') : 0
            if (starTimeArr.length > 0 && endTimeArr.length > 0) {
              this.examAndTime = starTimeArr[0] + ":" + starTimeArr[1] + "--" + endTimeArr[0] + ":" + endTimeArr[1]
            } else {
              this.examAndTime = '未知'
            }

            //  题目遍历
            if (data.data.data.paperOptions) {
              data.data.data.paperOptions.questionsArray.forEach(v => {
                const item = data.data.data.paperOptions.questionTypeArray.find(d => d.examsQuestionTypeId == v.examsQuestionTypeId)
                // 题目类型处理
                v.questionTypeTitle = item.questionTypeTitle
                //  得分与用户答案处理
                for (let key in data.data.data.answersOptions) {
                  if (v.examsQuestionId == key) {
                    v = Object.assign(v, data.data.data.answersOptions[key])
                  }
                }

                //  答案处理
                if (v.questionTypeTitle != '单选题' || v.questionTypeTitle != '多选题') {
                  v.answer = v.answer ? this.delHtmlTag(v.answer) : '暂无'
                  v.content = v.content ? this.delHtmlTag(v.content) : '暂无'
                  v.analyze = v.analyze ? this.delHtmlTag(v.analyze) : '暂无'
                  v.answerOptions = v.answerOptions ? this.delHtmlTag(v.answerOptions) : ''
                } else {
                  v.answer = v.answer
                }

                v.answerOptions = JSON.parse(v.answerOptions)
                v.answerTrueOption = JSON.parse(v.answerTrueOption)

                v.nameArr = []
                //将提取的键名作为数组的某个属性值
                for (let key in v.answerOptions) {
                  v.nameArr.push({
                    name: key + '、' + v.answerOptions[key]
                  })
                }

              })

              this.comprehensiveList = data.data.data.paperOptions.questionsArray ? data.data.data.paperOptions.questionsArray : []
              console.log(this.comprehensiveList);
            } else {
              this.comprehensiveList = []
            }
          }
        } else {
          this.$message.error(msg);
        }
      });
    },
    // 去除标签
    delHtmlTag(str) {
      return str.replace(/<[^>]+>/g, '').replace(/&nbsp;/ig, '')
    }


  },
};
</script>
<style lang='scss' scoped>
.active {
  margin-top: 0px !important;
  padding-top: 0 !important;
}

.tab {
  text-align: left;
  font-size: 0;

  .class-result {
    width: 100%;
    height: 40px;
    font-size: 20px;
    // background-color:#f6f6f6;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-between;

    .result-title {
      flex: 1;
      line-height: 40px;
      font-weight: 600;

      .result-bg {
        color: #409eff;
      }
    }
  }

  .control {
    display: flex;
    align-items: center;
    height: 60px;
    padding-left: 20px;
    background: #f6f6f6;
  }

  .tips_dialog {
    display: flex;
    align-items: center;

    .tips_dialog_title {
      width: 46px;
    }
  }
}

.examTime-box {
  width: 100%;
  height: 20px;
  display: flex;
  flex-direction: row;
  justify-content: center;

  .examTime {
    margin-right: 20px;
    font-weight: 600;
  }
}

.exam-info {
  //  height: 620px;
  //  overflow-y: scroll;

  .topic {
    margin-top: 30px;
    border-bottom: 1px solid #ccc;

    .header-box {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;

      .title-type {
        font-weight: 600;
        color: black;
      }

      .bg-active {
        color: #65a96e;
        font-weight: 600;
        margin-left: 10px;
      }
    }

    .question {

      .question-title {
        width: 100%;
        color: #a6a3a6;
        height: auto;
        margin: 20px 0;
      }

      .select-anwer {
        color: #a6a3a6;
        margin-bottom: 10px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;

        .anwer {
          margin-right: 30px;
        }
      }

      .anwer-box {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        margin: 20px 0;

        .anwer-user {
          margin-right: 20px;
        }

        .active {
          color: red;
        }
      }

      .analyze-box {
        color: #a6a3a6;
        padding-bottom: 20px;
      }
    }
  }


}

.table_control {
  color: #409eff;

  .table_control_item {
    vertical-align: middle;
    cursor: pointer;
  }
}

/deep/.score_status_time_dialog {

  // .el-dialog__body,
  // position: relative;

  .allScore {
    // position: absolute;
    // right: 13%;
    // bottom: 7%;
    width: 100%;
    text-align: right;
    margin-top: 20px;
    font-weight: 600;
    padding-bottom: 30px;
    font-size: 24px;

  }

  .el-dialog {
    background-color: #FFFFFF;
  }

  .el-dialog__footer {
    width: 1200px;
    background-color: #FFFFFF;
    display: flex;
    justify-content: center;
    // position: fixed;
    // bottom: 40px;
  }
}

/deep/ .generalScoreTips .el-input__inner::placeholder {
  color: #d9001b;
}

/deep/.indicatorIncomplete {
  color: #d9001b;

  .el-input__inner {
    color: #d9001b;
  }
}

/deep/.score_table .el-table__body-wrapper .el-table__body .el-table__row {
  td:nth-child(3) .cell {
    cursor: pointer;
  }

  td:nth-child(4) .cell {
    cursor: pointer;
  }

  td:nth-child(5) .cell {
    color: #00a7cc;
    cursor: pointer;
  }

  td:nth-child(6) .cell {
    color: #00a7cc;
    cursor: pointer;
  }

  td:nth-child(7) .cell {
    color: #00a7cc;
    cursor: pointer;
  }

  td:nth-child(8) .cell {
    color: #00a7cc;
  }

  td:nth-child(9) .cell {
    color: #00a7cc;
  }

  td:nth-child(10) .cell {
    color: #00a7cc;
    cursor: pointer;
  }

  td:nth-child(11) .cell {
    color: #00a7cc;
    cursor: pointer;
  }

  td:nth-child(12) .cell {
    color: #00a7cc;
    cursor: pointer;
  }

  td:nth-child(14) .cell {
    cursor: pointer;
  }
}

/deep/.el-collapse-item__header {
  display: none;
}

/deep/.el-collapse-item__wrap {
  border: none;
}

/deep/.el-collapse {
  border: none;
  padding-bottom: 20px;
}
</style>